import { render, staticRenderFns } from "./PaymentComponent.vue?vue&type=template&id=ff1842a0&scoped=true"
import script from "./PaymentComponent.vue?vue&type=script&lang=js"
export * from "./PaymentComponent.vue?vue&type=script&lang=js"
import style0 from "./PaymentComponent.vue?vue&type=style&index=0&id=ff1842a0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff1842a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff1842a0')) {
      api.createRecord('ff1842a0', component.options)
    } else {
      api.reload('ff1842a0', component.options)
    }
    module.hot.accept("./PaymentComponent.vue?vue&type=template&id=ff1842a0&scoped=true", function () {
      api.rerender('ff1842a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/payment/PaymentComponent.vue"
export default component.exports